import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for TopicPlan page */
export default class AudienceAcquisitionOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    includeTlm: PropTypes.bool.isRequired,
    run: PropTypes.bool.isRequired,
    selectedNetwork: PropTypes.string
  }

  static defaultProps = {
    includeTlm: true
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs New Audience Drivers for {this.props.selectedNetwork}!<br /><br />The New Audience Drivers dashboard provides a rolling 90-day view of engagement performance by title. The top chart features titles that are driving the greatest volume of net new audience engagers for the network or platform. The bottom chart features titles that are working hardest to engage existing audience members for the network or platform.<br/><br/>Let's Go!</p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      }
    ]

    return steps
  }
}
